import { HistoryUser } from '../../../api/models/admin';
import { dateTimeBodyRender } from '../../common/table/body-renders/date-time';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    name: 'id',
    label: '#',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'create_dt',
    label: 'Дата/время',
    options: {
      filter: {
        name: 'create_dt',
        type: 'date',
        onApply: (value: string) => value + 'T00:00:00',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(),
    },
  },
  {
    name: 'user',
    label: 'Пользователь',
    options: {
      filter: {
        name: 'full_name',
        type: 'text',
      },
      sort: true,
      customBodyRender: (user: HistoryUser) =>
        `(${user.user}) ${user.full_name}`,
    },
  },
  {
    name: 'url',
    label: 'URL',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'url_rule',
    label: 'URL правило',
    options: {
      hidden: true,
      filter: true,
      sort: true,
    },
  },
  {
    name: 'json_hash',
    label: 'JSON hash',
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: 'request_type',
    label: 'Тип запроса',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'source',
    label: 'Источник',
    options: {
      filter: false,
      sort: false,
    },
  },
];
